import {
  GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_ERROR,
  GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_SUCCESS,
  GET_DOWNLOAD_QUOTE_SEARCH_RESULTS
} from './QuoteSearchResults.actions'

const quoteSearchResultsState = {
  download: {
    error: undefined,
    loading: false
  }
}

/**
 * The quote search's reducer.
 */
const quoteSearchResultsReducer = (state = quoteSearchResultsState, { payload, type }) => {
  switch (type) {
    case GET_DOWNLOAD_QUOTE_SEARCH_RESULTS: {
      return { ...state, download: { ...state.download, error: undefined, loading: true } }
    }
    case GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_ERROR: {
      return { ...state, download: { ...state.download, error: payload.error, loading: false } }
    }
    case GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_SUCCESS: {
      return { ...state, download: { ...state.download, error: undefined, loading: false } }
    }
    default: {
      return state
    }
  }
}

export default quoteSearchResultsReducer
